import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { clearAlert } from '../store/slices/alertSlice';

const ALERT_LABELS = {
  success: 'Success',
  danger: 'Error',
  warning: 'Warning',
  info: 'Info',
};

const Alert = () => {
  const { message, type } = useSelector((state) => state.alert);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!message) return undefined;

    const timer = setTimeout(() => {
      dispatch(clearAlert());
    }, 5000);

    return () => clearTimeout(timer);
  }, [message, dispatch]);

  if (!message) return null;

  const alertType = type || 'info';

  return createPortal(
    <div className="app-toast-stack" aria-live="polite" aria-atomic="true">
      <div className={`app-toast app-toast-${alertType}`} role="alert">
        <div className="app-toast-body">
          <strong>{ALERT_LABELS[alertType] || ALERT_LABELS.info}:</strong> {message}
        </div>
        <button
          type="button"
          className="app-toast-close"
          onClick={() => dispatch(clearAlert())}
          title="Dismiss message"
          aria-label="Dismiss message"
        >
          <i className="bi bi-x" aria-hidden="true" />
        </button>
      </div>
    </div>,
    document.body
  );
};

export default Alert;
